// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__IBKrX","rootSmall":"AddTileButton_rootSmall__3M8Er"};